import React, { useEffect, useState } from "react";
import { withUserAndChat } from "~/common/Store/connectUserAndChat";
import { User } from "~/common/Store/models/User";
import AdCampaignData from "./AdCampaignData.json";
import PlusEssentialsPhase1Ad from "./PlusEssentialsPhase1Ad";
import PlusEssentialsPhase3Ad from "./PlusEssentialsPhase3Ad";
import PlusEssentialsPhase4Ad from "./PlusEssentialsPhase4Ad";
import PlusEssentialsPhase5Ad from "./PlusEssentialsPhase5Ad";
import getTrackingName from "./getTrackingName";
interface PlusEssentialsAdProps {
  user: User;
  pageType: PageType;
}
export type PageType = "Home" | "MyAccount";
const PlusEssentialsAd = ({
  user,
  pageType
}: PlusEssentialsAdProps) => {
  const [adTypeId, setAdTypeId] = useState(0);
  const [endDate, setEndDate] = useState("");
  const isHomePage = pageType === "Home";
  useEffect(() => {
    if (user.registered && !!user?.webPlusHomePageAdIds?.length && user.webPlusHomePageAdIds[0]) {
      setAdTypeId(user.webPlusHomePageAdIds[0].webPlusAdId);
      setEndDate(new Date(user.webPlusHomePageAdIds[0].adEndDate).toLocaleDateString());
    }
  }, [user.index, user.registered, user.webPlusHomePageAdIds]);
  const adCampaignData = AdCampaignData.find(x => x.id === adTypeId);
  if (adCampaignData === undefined) {
    return <></>;
  }
  const {
    desktopImage,
    accountDesktop,
    couponCode,
    dollarAmountSaved,
    link,
    name,
    tabletImage,
    tabletImageSmall,
    mobileBackgroundImage,
    mobileBackgroundImageSmall,
    trackingTier
  } = adCampaignData;
  const showPlusEssentialsAd1 = adTypeId < 13 && isHomePage;
  const showPlusEssentialsAd3 = adTypeId === 13;
  const showPlusEssentialsAd4 = adTypeId > 13 && adTypeId < 23;
  const showPlusEssentialsAd5 = adTypeId >= 23;
  const trackingName = getTrackingName(name, adTypeId, pageType);
  return <div className="container bg-white md:bg-transparent" data-sentry-component="PlusEssentialsAd" data-sentry-source-file="index.tsx">
      {showPlusEssentialsAd1 && <PlusEssentialsPhase1Ad backgroundImage={desktopImage} campaignEndDate={endDate} couponCode={couponCode} dollarAmountSaved={dollarAmountSaved} link={link} mobileBackgroundImage={mobileBackgroundImage} name={name} productImage={tabletImage} trackingName={trackingName} trackingTier={trackingTier} user={user} />}
      {showPlusEssentialsAd3 && <PlusEssentialsPhase3Ad backgroundImage={desktopImage} couponCode={couponCode} dollarAmountSaved={dollarAmountSaved} endDate={endDate} link={link} mobileBackgroundImage={mobileBackgroundImage} name={name} trackingName={trackingName} pageType={pageType} />}
      {showPlusEssentialsAd4 && <PlusEssentialsPhase4Ad desktopImage={desktopImage} accountDesktop={accountDesktop || ""} campaignEndDate={endDate} couponCode={couponCode} dollarAmountSaved={dollarAmountSaved} link={link} mobileBackgroundImage={mobileBackgroundImage} mobileBackgroundImageSmall={mobileBackgroundImageSmall || ""} name={name} tabletImage={tabletImage} tabletImageSmall={tabletImageSmall || ""} trackingName={trackingName} trackingTier={trackingTier} pageType={pageType} />}
      {showPlusEssentialsAd5 && <PlusEssentialsPhase5Ad backgroundImage={desktopImage} couponCode={couponCode} dollarAmountSaved={dollarAmountSaved} endDate={endDate} link={link} mobileBackgroundImage={mobileBackgroundImage} name={name} trackingName={trackingName} className={`${isHomePage ? "plus-essentials-5-hp" : ""}`} pageType={pageType} />}
    </div>;
};
export default withUserAndChat(PlusEssentialsAd);